/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Dropdown Arrow Icon component.
 */
export const DropdownArrowIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='DropdownArrowIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M7 10l5 5 5-5z'
          fillRule='evenodd'
          clipRule='evenodd'
          fill={iconColor} />
      </svg>
    )} />
  );
};
